module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-panel uikit-column",
    style: (_vm.getStyle),
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "openBlock"
  }, [_c('div', {
    staticClass: "blockHeader"
  }, [_c('div', {
    staticClass: "blockHeader_left"
  }, [_c('router-link', {
    staticClass: "home-url logo",
    attrs: {
      "to": {
        path: "/"
      }
    }
  }, [_c('AppPicture', {
    attrs: {
      "image": _vm.regionProfileLogo,
      "image-width": "40px",
      "image-height": "40px"
    }
  })], 1), _c('p', {
    staticClass: "region_name"
  }, [_vm._v(_vm._s(_vm.regionName))])], 1), _c('div', {
    staticClass: "blockHeader_right"
  }, [_c('ExtraButtons')], 1)]), _c('hr', {
    staticClass: "divide-line"
  }), (_vm.searchOpened) ? _c('div', {
    staticClass: "searchBlock"
  }, [_c('AppInput', {
    staticClass: "app_input",
    attrs: {
      "value": _vm.getValue(),
      "search": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pushRoute($event)
      }
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b348b6ea","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/userPanel/UserPanel.vue
// module id = 92cc33efa9ef4859f2b0
// module chunks = 0